import script from "./ShopTax.vue?vue&type=script&lang=ts&setup=true"
export * from "./ShopTax.vue?vue&type=script&lang=ts&setup=true"

import "./ShopTax.vue?vue&type=style&index=0&id=6d81521f&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d81521f"]])

export default __exports__